export default __webpack_public_path__ + "static/media/litros.5105fc6f.png";